import { BaseController } from '../../base/controller';

class ToggleControlController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({ controllerService });
  }

  $onInit() {
    this.showInfo = false;
  }
}

export default ToggleControlController;



// WEBPACK FOOTER //
// ./src/app/common/ui/toggleControl/toggleControl.controller.js